import React from 'react'

export const CheckSquareIcon = () => (
  <svg
    fill='none'
    height={14}
    viewBox='0 0 18 18'
    width={14}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M6.5625 8.02083L8.75 10.2083L16.0417 2.91667M15.3125 8.75V13.8542C15.3125 14.2409 15.1589 14.6119 14.8854 14.8854C14.6119 15.1589 14.2409 15.3125 13.8542 15.3125H3.64583C3.25906 15.3125 2.88813 15.1589 2.61464 14.8854C2.34115 14.6119 2.1875 14.2409 2.1875 13.8542V3.64583C2.1875 3.25906 2.34115 2.88813 2.61464 2.61464C2.88813 2.34115 3.25906 2.1875 3.64583 2.1875H11.6667'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
  </svg>
)
